export default "__VITE_ASSET__DnfG$ZQw__"